import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/question.svg'
import _imports_1 from '@/assets/guided-tour.svg'
import _imports_2 from '@/assets/printing-tips.svg'
import _imports_3 from '@/assets/printing-troubleshooting.svg'
import _imports_4 from '@/assets/alignment-wizard.svg'


_pushScopeId("data-v-271ad386")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "title" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("span", null, "Help")
  ]),
  /*#__PURE__*/_createElementVNode("div", { id: "place-holder" })
], -1)
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Guided Tour", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Let us show you around some of our important tools and features", -1)
const _hoisted_7 = {
  key: 0,
  class: "component"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "img-wrap",
  style: {"background":"#E9C2F0"}
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Printing Tips", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Get the perfect print with these expert printing tips for labels", -1)
const _hoisted_13 = {
  key: 1,
  class: "component"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "Printing Troubleshooting", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "We can help you troubleshoot some of the most common issues when printing", -1)
const _hoisted_18 = {
  key: 2,
  class: "component"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Alignment Wizard", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "Manually configure your label template to match your printer", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body", _ctx.bounceTransition])
      }, [
        _createElementVNode("div", {
          class: "close-svg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createVNode(_component_CloseSVG, {
            propId: 'help-close',
            fillColor: '#f7f9fc'
          })
        ]),
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass((!_ctx.isPrintable) ? 'not-printable component' : 'component')
          }, [
            _createElementVNode("div", {
              class: "img-wrap",
              style: {"background":"#fffcaf"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectHelp('guidedTour')))
            }, _hoisted_4),
            _hoisted_5,
            _hoisted_6
          ], 2),
          (_ctx.isPrintable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("a", {
                  href: _ctx.printingTips,
                  style: {"width":"100%","height":"100%"},
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, _hoisted_10, 8, _hoisted_8),
                _hoisted_11,
                _hoisted_12
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPrintable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: "img-wrap",
                  style: {"background":"#FF9595"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectHelp('troubleShooting')))
                }, _hoisted_15),
                _hoisted_16,
                _hoisted_17
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPrintable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: "img-wrap",
                  style: {"background":"#B7F8CB"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectHelp('alignmentWizard')))
                }, _hoisted_20),
                _hoisted_21,
                _hoisted_22
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2)
  ]))
}